import { PencilIcon } from '@heroicons/react/outline';
import styles from '../Applications.module.css';

interface IReviewProps {
  title: string;
  children: React.ReactNode;
  handleEdit: () => void;
}

export default function ReviewCard({
  handleEdit,
  children,
  title,
}: IReviewProps) {
  return (
    <div className={styles['card']}>
      <div className={styles['card-head-section']}>
        <h3 className={styles['card-title']}>{title}</h3>
        {/* <p className="mt-1 max-w-2xl text-sm text-gray-500">Personal details and application.</p> */}
        <div
          className='bg-gray-100 p-2 rounded-full hover:bg-blue-200 cursor-pointer'
          onClick={handleEdit}
        >
          <PencilIcon className='h-5 w-5 text-blue-500' />
        </div>
      </div>
      <div className={styles['card-body-section']}>{children}</div>
    </div>
  );
}
